// Client-side heartbeat function - fire and forget
// Uses fetch directly to avoid Server Action overhead and blocking
export async function recordDashboardHeartbeat(variables: {
  workspaceId?: string
  email?: string
  name?: string
  evaluationId?: string
}) {
  try {
    // Use fetch with a short timeout (5 seconds) - this is fire-and-forget
    // We don't need to wait for the response or block page rendering
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 5000) // 5 second timeout

    await fetch('/api/dashboard/heartbeat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(variables),
      signal: controller.signal,
      // Don't wait for response - fire and forget
      keepalive: true
    }).catch(() => {
      // Silently ignore errors - heartbeat is non-critical
    }).finally(() => {
      clearTimeout(timeoutId)
    })

    return { recordDashboardHeartbeat: { success: true, message: 'Heartbeat sent', memberId: null } }
  } catch (error) {
    // Silently ignore - heartbeat is non-critical
    return { recordDashboardHeartbeat: { success: false, message: 'Failed to send heartbeat', memberId: null } }
  }
}

